// FIXME: Due to a circular dependency issues, we cannot use `~utils` import
import { translate } from "utils/string-table";

export const computeInitialSelected = (validList: string[], initialSelection: string[]) => {
  if (initialSelection.every((item) => validList.includes(item))) {
    return initialSelection;
  }
  return [translate("UNKNOWN")];
};
